import { SchemaTypes } from '@allesauto/graphql';
import translate from '@allesauto/i18n';
import { isSpecialCharacter } from '@allesauto/utils/funcs';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

export interface CarSellerDetailsProps {
  location: SchemaTypes.Location;
}

const CarSellerDetails: FC<React.PropsWithChildren<CarSellerDetailsProps>> = ({
  location: { zip, city },
}) => {
  const intl = useIntl();

  return (
    <div className="flex flex-1 flex-col mt-auto order-2 w-full sm:col-end-24 sm:col-start-2 sm:pb-0 md:col-end-24 md:col-start-20 md:order-none md:pb-0">
      <p className="font-weight-bold pb-5px pt-20px text-p1 text-purple80 md:pb-10px md:pt-0 monochrome:text-black">
        {translate(intl, 'ui.PDP.C2C.SELLER_DETAILS_TITLE')}
      </p>
      <p className="pb-20px md:pb-0">
        {zip && !isSpecialCharacter(zip) && zip}{' '}
        {city && !isSpecialCharacter(city) && city}
      </p>
    </div>
  );
};

export default CarSellerDetails;
